module.exports = __webpack_public_path__ + "innovation.1kuT5bSP.svg";